import React, {useState, useEffect, useCallback} from 'react';
import moment from 'moment';
import SendIcon from "@material-ui/icons/Send";
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import { debounce } from "lodash";
import { useDispatch, useSelector,shallowEqual } from 'react-redux';
import ModalSendImage from './ModalSendImage';
import * as contactsActions from '../../../state/contacts/actions';
import * as authSelectors from '../../../state/auth/selectors';
import * as campaignsSelector from '../../../state/channels/selectors';
import AutoResponsesFileNew from './AutoResponsesFileNew';
import ChatOffline from './ChatOffline';

import { Input, IconButton, TextField, Button } from "@material-ui/core";

import Api from '../../../state/Api';



const SendBoxLive = ( props ) => {

  const classes = props.classes;
  const campaigns = []
  const [modalSendImageOpen, setModalSendImageOpen ] = useState(false)
  const [modalMostrarUtms, setModalMostrarUtms ] = useState(false)
  const [selectedImage, setSelectedImage ] = useState('');
  const [outgoingMessage, setMessage] = useState('');
  const [linkParams, setLinkParams] = useState({});
  const [habilitadoMic, setHabilitadoMic] = useState(false);
  const [recording, setRecording] = useState(false);
  const [corrigiendo, setCorrigiendo] = useState(false);



  const dispatch = useDispatch();
  
  const handleModalImageClose = () => {
    setModalSendImageOpen(false)
    setSelectedImage('')
  }

  const handleSendUtms = (msg) => {
    setMessage(msg);
    sendMessage()
  }

  const sendMessage = (initialMessage) => {

    Api.req.put(`https://live.tevecompras.com/api/live-shopping/chat`, { msg : outgoingMessage})
        .then((response) => {
           setMessage('')
        })
    /*props.socket.emit('chat:message', {
      user: 'TeVeCompras',
      email: 'atcliente@tevecompras.com',
      host: true,
      text: outgoingMessage,
      timestamp: new Date().toISOString()
    })*/
  
  }
  
  const handleMessageChange = event => {
    setMessage(event.target.value);
  };

  const me = useSelector(authSelectors.getMe(), shallowEqual);

    const keyPressEvent = (event) => {
      if (event.key === 'Enter' &&  event.shiftKey ) {

      }else if (event.key === 'Enter' && outgoingMessage) {
        sendMessage(); event.preventDefault() 
      } else if (event.key === 'Enter') {
        event.preventDefault() 
      }
    }

    return (
      <>
          <div style={{ width: '100%' }}>
            <div style={{ height: '80px' }}  >
              <TextField
                id="reply-msg"
                className={classes.rootSendBox}
                placeholder="Escribir mensaje"
                value={outgoingMessage}
                onChange={(e) => { handleMessageChange(e) }}
                onKeyPress={event => keyPressEvent(event)}
                multiline
                fullWidth
                lang='es'
                spellCheck="true"
                rows={3}
                variant="outlined"
              />
            </div>
           
          </div>
      </>
    )
  
}

  export default SendBoxLive;